import { render, staticRenderFns } from "./CompanionMenu.vue?vue&type=template&id=145fc1f2&scoped=true&"
import script from "./CompanionMenu.vue?vue&type=script&lang=js&"
export * from "./CompanionMenu.vue?vue&type=script&lang=js&"
import style0 from "./CompanionMenu.vue?vue&type=style&index=0&id=145fc1f2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145fc1f2",
  null
  
)

export default component.exports